// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer_left .social_footer h3 {
    display: block;
}

.footer_brand_logo {
    display: inline-flex;
    margin: 0 0 16px;
}

.footer_brand_logo img {
    width: 84px;
    height: auto;
    display: block;
}

.footer_app_download {
    width: 100%;
    text-align: left;
    padding: 0 0 4px;
    color: #ffffff;
}

.footer_app_download h2 {
    margin: 0 0 8px;
    max-width: none;
    color: #ffffff;
    font-size: 20px;
    font-weight: 600;
    line-height: 1.25;
    letter-spacing: -0.02em;
    text-transform: none;
    text-align: left;
}

.footer_app_download>p {
    margin: 0 0 14px;
    max-width: none;
    color: #9aa0a6;
    font-size: 13px;
    font-weight: 400;
    line-height: 1.45;
}

.footer_app_download__actions {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 12px;
    width: 100%;
}

.footer_app_dl__card {
    position: relative;
    width: auto;
}

.footer_app_dl__icon {
    width: 44px;
    height: 44px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: 1.5px solid #d1aa67;
    border-radius: 50%;
    background: transparent;
    color: #d1aa67;
    cursor: pointer;
    transition: background-color 0.15s ease, color 0.15s ease;
}

.footer_app_dl__icon i {
    font-size: 20px;
    line-height: 1;
    color: #d1aa67;
}

.footer_app_dl__icon:hover {
    background: #d1aa67;
    color: #181a20;
}

.footer_app_dl__icon:hover i {
    color: #181a20;
}

.footer_app_dl__popover {
    display: none;
    position: absolute;
    left: 0;
    bottom: calc(100% + 12px);
    z-index: 5;
    width: 210px;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 14px 14px 12px;
    border-radius: 14px;
    background: #ffffff;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.28);
}

.footer_app_dl__popover::before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: -16px;
    height: 16px;
}

.footer_app_dl__popover::after {
    content: "";
    position: absolute;
    left: 16px;
    bottom: -6px;
    width: 12px;
    height: 12px;
    background: #ffffff;
    transform: rotate(45deg);
}

footer .footer_app_dl__popover a {
    color: #111111;
    font-size: 14px;
    font-weight: 700;
    text-decoration: none;
}

footer .footer_app_dl__popover a:hover {
    color: #8a6a2f;
}

.footer_app_dl__card:hover .footer_app_dl__popover {
    display: flex;
}

.footer_app_dl__popover img {
    width: 148px;
    height: 148px;
    object-fit: contain;
    background: #ffffff;
}

footer .footer_app_dl__popover p {
    margin: 0;
    color: #111111;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.4;
}

@media (max-width: 767px) {
    .footer_app_download h2 {
        font-size: 18px;
    }
}

/* Light theme uses a global footer text color. Keep this block identical to dark. */
body.light_theme footer .footer_app_download,
body.light_theme footer .footer_app_download h2 {
    color: #090909;
}

body.light_theme footer .footer_app_download>p {
    color: #2d2d2d;
}

body.light_theme footer .menu li a {
    color: #434343;
}

body.light_theme footer .footer_trade_crypto_toggle {
    color: #434343;
}

body.light_theme footer .footer_app_dl__popover,
body.light_theme footer .footer_app_dl__popover::after {
    background: #ffffff;
    color: #111111;
}

body.light_theme footer .footer_app_dl__popover p,
body.light_theme footer .footer_app_dl__popover a {
    color: #111111;
}

body.light_theme footer .footer_app_dl__popover a:hover {
    color: #8a6a2f;
}

body.light_theme footer .footer_app_dl__icon,
body.light_theme footer .footer_app_dl__icon i {
    background: transparent;
    color: #d1aa67;
    border-color: #d1aa67;
}

body.light_theme footer .footer_app_dl__icon:hover {
    background: #d1aa67;
    color: #181a20;
}

body.light_theme footer .footer_app_dl__icon:hover i {
    background: transparent;
    color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/customComponents/Footer/footer-app-download.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,2BAA2B;IAC3B,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,yDAAyD;AAC7D;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,OAAO;IACP,yBAAyB;IACzB,UAAU;IACV,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA,oFAAoF;AACpF;;IAEI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,uBAAuB;IACvB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,WAAW;AACf","sourcesContent":[".footer_left .social_footer h3 {\n    display: block;\n}\n\n.footer_brand_logo {\n    display: inline-flex;\n    margin: 0 0 16px;\n}\n\n.footer_brand_logo img {\n    width: 84px;\n    height: auto;\n    display: block;\n}\n\n.footer_app_download {\n    width: 100%;\n    text-align: left;\n    padding: 0 0 4px;\n    color: #ffffff;\n}\n\n.footer_app_download h2 {\n    margin: 0 0 8px;\n    max-width: none;\n    color: #ffffff;\n    font-size: 20px;\n    font-weight: 600;\n    line-height: 1.25;\n    letter-spacing: -0.02em;\n    text-transform: none;\n    text-align: left;\n}\n\n.footer_app_download>p {\n    margin: 0 0 14px;\n    max-width: none;\n    color: #9aa0a6;\n    font-size: 13px;\n    font-weight: 400;\n    line-height: 1.45;\n}\n\n.footer_app_download__actions {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 12px;\n    width: 100%;\n}\n\n.footer_app_dl__card {\n    position: relative;\n    width: auto;\n}\n\n.footer_app_dl__icon {\n    width: 44px;\n    height: 44px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    border: 1.5px solid #d1aa67;\n    border-radius: 50%;\n    background: transparent;\n    color: #d1aa67;\n    cursor: pointer;\n    transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.footer_app_dl__icon i {\n    font-size: 20px;\n    line-height: 1;\n    color: #d1aa67;\n}\n\n.footer_app_dl__icon:hover {\n    background: #d1aa67;\n    color: #181a20;\n}\n\n.footer_app_dl__icon:hover i {\n    color: #181a20;\n}\n\n.footer_app_dl__popover {\n    display: none;\n    position: absolute;\n    left: 0;\n    bottom: calc(100% + 12px);\n    z-index: 5;\n    width: 210px;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n    padding: 14px 14px 12px;\n    border-radius: 14px;\n    background: #ffffff;\n    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.28);\n}\n\n.footer_app_dl__popover::before {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: -16px;\n    height: 16px;\n}\n\n.footer_app_dl__popover::after {\n    content: \"\";\n    position: absolute;\n    left: 16px;\n    bottom: -6px;\n    width: 12px;\n    height: 12px;\n    background: #ffffff;\n    transform: rotate(45deg);\n}\n\nfooter .footer_app_dl__popover a {\n    color: #111111;\n    font-size: 14px;\n    font-weight: 700;\n    text-decoration: none;\n}\n\nfooter .footer_app_dl__popover a:hover {\n    color: #8a6a2f;\n}\n\n.footer_app_dl__card:hover .footer_app_dl__popover {\n    display: flex;\n}\n\n.footer_app_dl__popover img {\n    width: 148px;\n    height: 148px;\n    object-fit: contain;\n    background: #ffffff;\n}\n\nfooter .footer_app_dl__popover p {\n    margin: 0;\n    color: #111111;\n    font-size: 13px;\n    font-weight: 600;\n    line-height: 1.4;\n}\n\n@media (max-width: 767px) {\n    .footer_app_download h2 {\n        font-size: 18px;\n    }\n}\n\n/* Light theme uses a global footer text color. Keep this block identical to dark. */\nbody.light_theme footer .footer_app_download,\nbody.light_theme footer .footer_app_download h2 {\n    color: #090909;\n}\n\nbody.light_theme footer .footer_app_download>p {\n    color: #2d2d2d;\n}\n\nbody.light_theme footer .menu li a {\n    color: #434343;\n}\n\nbody.light_theme footer .footer_trade_crypto_toggle {\n    color: #434343;\n}\n\nbody.light_theme footer .footer_app_dl__popover,\nbody.light_theme footer .footer_app_dl__popover::after {\n    background: #ffffff;\n    color: #111111;\n}\n\nbody.light_theme footer .footer_app_dl__popover p,\nbody.light_theme footer .footer_app_dl__popover a {\n    color: #111111;\n}\n\nbody.light_theme footer .footer_app_dl__popover a:hover {\n    color: #8a6a2f;\n}\n\nbody.light_theme footer .footer_app_dl__icon,\nbody.light_theme footer .footer_app_dl__icon i {\n    background: transparent;\n    color: #d1aa67;\n    border-color: #d1aa67;\n}\n\nbody.light_theme footer .footer_app_dl__icon:hover {\n    background: #d1aa67;\n    color: #181a20;\n}\n\nbody.light_theme footer .footer_app_dl__icon:hover i {\n    background: transparent;\n    color: #fff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
